import {DatabaseCode, toDatabaseCode} from "./database-code";

export type TagAssignmentKind = DatabaseCode;

const auto: TagAssignmentKind = {
  code: "AUTO",
  displayValue: {
    id: "common.entity.tagassignmentkind.auto",
    defaultMessage: "Auto",
  },
};

const manual: TagAssignmentKind = {
  code: "MANUAL",
  displayValue: {
    id: "common.entity.tagassignmentkind.manual",
    defaultMessage: "Manual",
  },
};

export const tagAssignmentKind = {
  auto,
  manual,
};

export const tagAssignmentKinds = Object.values(tagAssignmentKind);

export const toTagAssignmentKind = (code: string): TagAssignmentKind =>
  toDatabaseCode(code, tagAssignmentKinds);

export const toTagAssignmentKindSafely = (
  code: string | undefined
): TagAssignmentKind | undefined =>
  code ? toDatabaseCode(code, tagAssignmentKinds) : undefined;
